module.exports = __webpack_public_path__ + "static/media/xls.19b9e138.svg";